import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent implements OnInit, OnChanges {
  public backgroundImg: SafeStyle;
  @Input() url: string;
  @Input() small: boolean = false;

  private defaultUrl: string = '/assets/iconmoon-icons/Profile.svg';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.setUrl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setUrl();
  }

  setUrl(): void {
    if (!this.url) {
      this.url = this.defaultUrl;
    }

    this.backgroundImg = this.sanitizer.bypassSecurityTrustStyle('url(' + this.url + ')');
  }
}
